import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { getApiErrorMessage } from "@/helpers/get-api-error-message";
import { inviteProfessionalsBulk } from "../services/invite-professionals-bulk";

/**
 * No success toast: the modal stays open and renders the per-person result
 * instead. A toast saying "invited 58 of 62" would bury the four that failed,
 * which are the only rows anyone needs to act on.
 */
export function useInviteProfessionalsBulk() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (professionalIds: string[]) => inviteProfessionalsBulk(professionalIds),
    onSuccess: () => {
      // Those just invited are no longer invitable. Without this the list keeps
      // offering them for 30 minutes, which is how long it caches.
      queryClient.invalidateQueries({ queryKey: ["professionals"] });
      queryClient.invalidateQueries({ queryKey: ["all-professionals"] });
    },
    onError: (error: unknown) => {
      // Only fires when the whole request failed — a per-person failure comes
      // back inside a successful response.
      toast({
        title: getApiErrorMessage(error, "Could not send the invitations"),
        variant: "destructive",
      });
    },
  });
}
